import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { OPEN_HINT_DIALOG } from "../Component/HintDialog";
import { labelData } from "../utils";
const ExcelJs = require('exceljs');

function Import () {
  const [data, setData] = useState(null);
  const [mailState, setMailState] = useState('送信中...');
  const [open, setOpen] = useState(false);
  const {handleSubmit, register, formState: {errors}} = useForm();
  const importExcel = async e => {
    const files = e.target.files;
    if (files.length === 0) {
      return;
    }

    setData(files);
  }

  const readFile = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = async e => {
      try {
        resolve(e.target.result);
      }catch (e) {
        reject(e);
      }
    }
    reader.readAsDataURL(file);
  })

  //讀取excel資料用，以後做其他功能會用到，別刪
  const parseExcel = (state) => async () => {
    if(data.length === 0) {
      return;
    }

    const file = data[0];
    const fileData = await readFile(file);
    const workbook = new ExcelJs.Workbook();
    await workbook.xlsx.load(fileData, {base64: true});
    const worksheet = workbook.worksheets[0];
    const params = [];

    function isEmail(email) {
      const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
    }

    //匯入人員名單
    if (state === 'user') {
      const passData1 = {api: 'user', action: 'list'};
      const url1 = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
      const response1 = await axios.post(url1, passData1);
      const userList = response1.data.data.rows.map(row => labelData(response1.data.data.columns, row));

      worksheet.eachRow((row, i) => {
        if (i === 1) return;
        const name = row.getCell(2).value;
        const phone = row.getCell(4).value ? '0' + row.getCell(4).value : '';
        const email = isEmail(row.getCell(5).value) ? row.getCell(5).value : '';
        if (params.find(({name: n}) => n === name)) {
          console.log('重複的名字: ' + name)
          return;
        }
        const exist = userList.find(({name: n}) => n === name);
        if (exist) {
          console.log("已有" + name);
          return;
        }
        params.push({name, phone, email})
      })

      // params.forEach(row => {
      //   const {name, phone, email} = row;
      //   const exist = userList.find(({name: n}) => n === name);
      //   if (!exist) {
      //     console.log('新增', name, phone, email)
      //     return;
      //   }else{
      //     console.log('已有', name, phone, email)
      //   }
      //   if (phone !== exist.phone) {
      //     console.log(name + '電話有變', phone, exist.phone)
      //     return;
      //   }
      //   if (email !== exist.email) {
      //     console.log(name + '信箱有變', email, exist.email)
      //     return;
      //   }
      // })

      // const passData = {api: 'user', action: 'addAll', data: params};
      // const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
      // const response = await axios.post(url, passData);
    }

    //匯入場次
    if (state === 'user_session') {
      worksheet.eachRow((row, i) => {
        if (i !== 1) return;
        const name = row.getCell(2).value;
        const session = row.getCell(8).value;
        const count = row.getCell(7).value;
        const accompany = row.getCell(3).value;
        if (session.includes('金剛力灌頂')) params.push({name, person_count: Number(count), accompany, _session_id: 1})
        if (session.includes('時輪金剛灌頂')) params.push({name, person_count: Number(count), accompany, _session_id: 2})
        if (session.includes('時輪金剛、香巴拉與世界和平國際論壇')) params.push({name, person_count: Number(count), accompany, _session_id: 3})
        if (session.includes('篤布巴暨時輪九尊世界和平祈福大法會')) params.push({name, person_count: Number(count), accompany, _session_id: 4})
      })

      // const passData = {api: 'user_session', action: 'addAll', data: params};
      // const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
      // const response = await axios.post(url, passData);
    }

    if (state === 'has_pay') {
      const passData1 = {api: 'user_session', action: 'list'};
      const url1 = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
      const response1 = await axios.post(url1, passData1);
      const userSessionList = response1.data.data.rows.map(row => labelData(response1.data.data.columns, row));

      worksheet.eachRow((row, i) => {
        if (i === 1) return;
        const name = row.getCell(2).value;
        const session = row.getCell(8).value;
        const count = row.getCell(7).value;
        const accompany = row.getCell(3).value;
        // const has_pay = row.getCell(49).value && (row.getCell(49).value.includes('已繳費') || row.getCell(49).value.includes('無須繳費')) ? true : false;
        const has_pay = Boolean(count > 1 && accompany);
        let exist;
        if (session.includes('金剛力灌頂') && has_pay) {
          exist = userSessionList.find(({user_name, _session_id}) => user_name === name && _session_id === 1);
          if (!exist) {
            console.log(name, 1)
          }else {
            // if (exist.has_pay === 0) {
              params.push({_id: exist._id, accompany})
            // }
          }
        }
        if (session.includes('時輪金剛灌頂') && has_pay) {
          exist = userSessionList.find(({user_name, _session_id}) => user_name === name && _session_id === 2);
          if (!exist) {
            console.log(name, 2)
          }else {
            // if (exist.has_pay === 0) {
              params.push({_id: exist._id, accompany})
            // }
          }
        }
        if (session.includes('時輪金剛、香巴拉與世界和平國際論壇') && has_pay) {
          exist = userSessionList.find(({user_name, _session_id}) => user_name === name && _session_id === 3);
          if (!exist) {
            console.log(name, 3)
          }else {
            // if (exist.has_pay === 0) {
              params.push({_id: exist._id, accompany})
            // }
          }
        }
        if (session.includes('篤布巴暨時輪九尊世界和平祈福大法會') && has_pay) {
          exist = userSessionList.find(({user_name, _session_id}) => user_name === name && _session_id === 4);
          if (!exist) {
            console.log(name, 4)
          }else {
            // if (exist.has_pay === 0) {
              params.push({_id: exist._id, accompany})
            // }
          }
        }
      })
      console.log(params)

      // const passData = {api: 'user_session', action: 'setAll', data: params};
      // const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
      // const response = await axios.post(url, passData);
    }
  }

  const sendMailTest = handleSubmit(async (data) => {
    setOpen(true);
    const passData = {api: 'user', action: 'sendMailTest', email: data.email};
    const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
    const response = await axios.post(url, passData);
    setMailState('送信完成');
  });

  const sendMail = async () => {
    setOpen(true);
    const passData = {api: 'user', action: 'sendMail'};
    const url = process.env.NODE_ENV === 'development' ? `http://${document.location.hostname}/check-in/public/api/` : '/api/';
    const response = await axios.post(url, passData);
    setMailState('送信完成');
  }

  const onClose = () => {
    setMailState('送信中...');
    setOpen(false);
  }

  return (
    <>
      <Button component="label">
        匯入
        <input hidden type="file" multiple={false} onChange={importExcel}/>
      </Button>
      <Button onClick={parseExcel('user')}>
        上傳人員
      </Button>
      <Button onClick={parseExcel('user_session')}>
        上傳相應場次
      </Button>
      <Button onClick={parseExcel('has_pay')}>
        上傳付款狀態
      </Button>
      <TextField {...register('email', {required: true})}/>
      <Button onClick={sendMailTest}>
        測試送信
      </Button>
      <Button onClick={sendMail}>送信</Button>
      <Dialog open={open} onClose={onClose}>
        <DialogTitle>送信提示</DialogTitle>
        <DialogContent>{mailState}</DialogContent>
        {mailState !== '送信中...' && <DialogActions>
          <Button onClick={onClose}>關閉</Button>
        </DialogActions>}
      </Dialog>
    </>
  )
}

export default Import;